import { getWeightedFilteredResults } from './getWeightedFilteredResults';

export const filterSearchResults = ({ searchResults, activeFilters, products }) => {
  if (!activeFilters.tags?.length) {
    return searchResults || [];
  }
  const weightedResults = getWeightedFilteredResults({
    searchResults: searchResults,
    activeFilters: activeFilters.tags,
    products,
  });

  return weightedResults.sort((a, b) => b.weight - a.weight).map(weightedResult => weightedResult.result);
};
